<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-toolbar flat>
          <v-text-field v-model="batchSize" append-icon="mdi-rocket" label="How many in this batch?" single-line
            hide-details>
          </v-text-field>
          <v-spacer></v-spacer>
          <v-btn @click="processMigration()" :loading="responseProcessing" color="primary" absolute right>Migrate Batch
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-alert  dismissible close-text="Close Alert" border="left" :type="responseStatus" v-if="responseStatus">
          {{ migrationResponseMessage }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";

export default {
  data: () => ({
    batchSize: null,
    responseStatus: null,
    migrationResponseMessage: null,
    responseProcessing: false
  }),
  computed: {
  },

  methods: {
    async processMigration() {

      if (this.batchSize == null || isNaN(this.batchSize) || this.batchSize <= 0) {
        this.responseStatus = "error";
        this.migrationResponseMessage = "Enter a numerical batch size > 0!"
        return;
      }

      this.responseProcessing = true;
      this.responseStatus = null;
      this.migrationResponseMessage = null;

      const migratePostImageBatchRequest = serverFunctions.getDataRequestObject(userFunctions.getLoggedInUser(), this.batchSize);

      let migrationResponse = await serverFunctions.getRawPostResponse("/migratePostImages", migratePostImageBatchRequest);

      this.responseProcessing = false;

      if (migrationResponse && migrationResponse.success) {
        this.responseStatus = "success";
        this.migrationResponseMessage = migrationResponse.successMessage;
      } else {
        this.responseStatus = "error";
        this.migrationResponseMessage = (migrationResponse) ? migrationResponse.failureReason : "Migration Failed" ;
      }

    },
  },
};
</script>

<style scoped>
</style>
